export default __webpack_public_path__ + "static/media/EmilyMendelson.d1e6f83f.jpg";